/*
 * @Author: 赵大壮 372839241@qq.com
 * @Date: 2025-08-24 21:27:23
 * @LastEditors: 赵大壮 372839241@qq.com
 * @LastEditTime: 2026-04-06 23:04:09
 * @FilePath: \利享乡村管理后台\src\views\审核管理\service\DZServiceHomestay.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import nyNetwork from "@/api/nyBaseNetwork";
import DZSearchHomestay from "@/views/审核管理/model/search/DZSearchHomestay";
import DZModelAddress from "@/views/审核管理/model/DZModelAddress";
import DZModelContacts from "@/views/审核管理/model/DZModelContacts";
import DZModelHomestayBase from "@/views/审核管理/model/DZModelHomestayBase";
import DZModelListHomestay from "@/views/审核管理/model/list/DZModelListHomestay";

class DZServiceHomestay{

    m_search = new DZSearchHomestay(10);

    /** 民宿审核列表 **/
    list_homestay : Array<DZModelListHomestay> = [];

    /** 民宿基本信息 **/
    base = new DZModelHomestayBase();
    /** 位置 **/
    address = new DZModelAddress();
    /** 联系人 **/
    contact = new DZModelContacts();

    sum = {
        all:'',
        listed:'',
        delisted:'',
        unaudited:''
    }

    net_page_homestay(){
        let arr = this.m_search.countyArr
        if(arr.length != 0){
            this.m_search.level = String(arr.length)
            this.m_search.county = arr[arr.length-1]
        }
        nyNetwork.net("民宿信息审核列表",this.m_search, data => {
            this.list_homestay = data.list
            this.m_search.total = data.total
        })
        nyNetwork.net("民宿信息审核列表统计",this.m_search, res => {
            if(res){
                this.sum.all = res.all
                this.sum.listed = res.listed
                this.sum.delisted = res.delisted
                this.sum.unaudited = res.unaudited
            }
        })
    }

    net_homestay_info(id){
        nyNetwork.net("民宿信息详情",{id:id}, data => {
            this.base = data.baseInfo
            this.address = data.addressInfo
            this.contact = data.contactsInfo
        })
    }

    net_edit_homestay_base(m_base){
        nyNetwork.net("修改民宿基本信息",m_base, data => {
            //success()
        })
    }

    net_edit_address(m_address){
        nyNetwork.net("修改民宿位置",m_address, data => {
            //success()
        })
    }

    net_edit_contact(m){
        nyNetwork.net("修改民宿联系人",m, data => {
            //success()
        })
    }

    net_homestay_pass(id,success: () => void){
        nyNetwork.net("民宿审核通过",{id:id}, data => {
            success()
        })
    }

    net_homestay_refuse(id,success: () => void){
        nyNetwork.net("民宿审核拒绝",{id:id}, data => {
            success()
        })
    }

    net_homestay_operate(id,success: () => void){
        nyNetwork.net("民宿暂停/继续发布",{id:id}, data => {
            success()
        })
    }

    net_batch_deList(idList,success: () => void){
        nyNetwork.net("民宿批量下架",[...idList], data => {
            success()
        })
    }

}
export default DZServiceHomestay;
